import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TrTabsComponent } from './tr-tabs.component';

@NgModule({
    imports: [
        CommonModule,
    ],
    declarations: [
        TrTabsComponent,
    ],
    exports: [
        TrTabsComponent,
    ]
})
export class TrTabsMobule {}
